import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { notificationActions } from 'store/notification';
import { Toast, ToastContainer } from 'components/UI_kit_3/Toast/Toast';

const NotificationContainer = () => {
  const notifications = useSelector((state: RootState) => state.notification);
  const dispatch = useDispatch();

  const handleClose = React.useCallback((id) => {
    dispatch(notificationActions.remove(id));
  }, []);

  return (
    <ToastContainer position="top-end">
      {
        notifications.map((notification) => (
          <Toast
            key={notification.id}
            onClose={() => handleClose(notification.id)}
            variant={notification.variant}
            autohide
            delay={5000}
            title={notification.title}
            message={notification.message}
          />
        ))
      }
    </ToastContainer>
  );
};

export default NotificationContainer;
